// extracted by mini-css-extract-plugin
export default {"BooleanFeature":"vr_a bhb_b"};